export enum CfgName {
    LOGO_URL = 'LOGO_URL', // URL da Logomarca do estabelecimento
    COMPANY_TEXT_COLOR = 'COMPANY_TEXT_COLOR', // Cor do texto exibido com a logomarca para impressões e envios por email
    COMPANY_BACKGROUND_COLOR = 'COMPANY_BACKGROUND_COLOR', // Cor de fundo da logomarca para impressões e envios por email
    LANGUAGE = 'LANGUAGE', // Idioma padrão do estabelecimento
    LOCALE = 'LOCALE', // Locale utilizado para formatação de data e valores
    CURRENCY = 'CURRENCY', // Código ISO 4217 da moeda gravada no pedido (Order.currency) e entregue ao integrador
    TIMEZONE = 'TIMEZONE', // Fuso horário
    ORDER_SYNC_TIMEOUT_MINUTES = 'ORDER_SYNC_TIMEOUT_MINUTES', // Minutos até um pedido não sincronizado com o PDV ser marcado como atrasado
    // Virada do DIA DE OPERAÇÃO ('HH:mm', fuso da empresa): zera o número curto do pedido (F15/D206) e
    // expira o "abrir agora" do ponto de venda. Uma virada só para o produto inteiro.
    ORDER_NUMBER_RESET_TIME = 'ORDER_NUMBER_RESET_TIME',
    TABLE_SESSION_TTL_MINUTES = 'TABLE_SESSION_TTL_MINUTES', // Validade da sessão de mesa emitida a partir do QR Code
    // Geolocalização é do ESTABELECIMENTO (empresa), não do ponto de venda — o PDV usa a config da empresa
    GEO_ENABLED = 'GEO_ENABLED', // '1'/'0' — valida se o cliente está dentro do raio do estabelecimento
    GEO_LATITUDE = 'GEO_LATITUDE', // Latitude do estabelecimento (graus decimais)
    GEO_LONGITUDE = 'GEO_LONGITUDE', // Longitude do estabelecimento (graus decimais)
    GEO_RADIUS_METERS = 'GEO_RADIUS_METERS', // Raio de aceitação em metros
    // M2-D60 — '1'/'0': o cardápio mostra "Chamar garçom" nas mesas. Desligado por padrão: o botão promete
    // que alguém vai aparecer, e só a empresa sabe se olha o painel.
    WAITER_CALL_ENABLED = 'WAITER_CALL_ENABLED',
    // M2-D68 — som de cada tipo de aviso do painel, por empresa. Valor é um `AlertSoundId`; desconhecido ou
    // ausente cai no padrão do tipo (`ALERT_SOUND_SLOTS`, em alert-sound.ts).
    NEW_ORDER_SOUND = 'NEW_ORDER_SOUND',
    WAITER_CALL_SOUND = 'WAITER_CALL_SOUND',
}